import React from 'react'
import Template from '../template/Template'
import notepad from "../../../media/notepad";
import loginSignup from '../../../media/loginSignup'
export default function NodeJs(props) {
  const Css = {
    "--background": `${props.isValue ? props.mode : 'red'}`
  }
  return (
    <>
      <div className="bodyCon projectCon">
        <div className="bodyComponent">
          <div className="aboutHeading projectHeading" style={Css}>

            <h1>Node Js</h1>
            <div className="container">
              <div className="projects">
                <a href='https://github.com/Zer-0ne/LoginForm' target='_blank' rel="noreferrer">
                  <Template img={loginSignup} />
                </a>
                <a href='https://github.com/Zer-0ne/iNotesBook' target='_blank' rel="noreferrer">
                  <Template img={notepad} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
